import './core/dependencies';
import './core/i18n';
import './core/filters';
import './core/helpers';
import './core/directives';
import './core/components';
import './services/echo';
import '../sass/preflight.css';
import 'tailwindcss/tailwind.css';
import './services/forms/bootstrap';
import bindings from './core/bindings';
import { docReady } from './integrations/unified/docReady';

new Vue({
  data: {
    user: BulldeskSettings.user || null,
    env: BulldeskSettings.env || null,
    store: {
      user: BulldeskSettings.user || null,
      users: [],
      tenantFields: [],
    },
  },
  created() {
    if (this.user) {
      this.user.admin = this.user.role > 0;
      this.user.root = this.user.role === 1;
    }

    Bus.$emit('user', this.user);

    Bus.$on('fieldsRetrieved', (fields) => {
      this.store.tenantFields = fields;
    });
  },

  methods: {
    BusEmit(event, data) {
      Bus.$emit(event, data);
    },
  },
}).$mount('#bulldesk');

docReady(() => bindings());
